module.exports = __webpack_public_path__ + "static/media/sell_change_request_5-2.0f7bd542.png";